import { Avatar, AvatarSizes } from "@inno-ui/avatar";
import { Icon, IconSizes, IconWeight } from "@inno-ui/icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import type { AvailableSlotsQueryDTO } from "../../../api/available-slots/available-slots.types";

import { useGetAvailableTimeSlots } from "../../../hooks/api/use-get-available-time-slots";
import { useAppointmentStore } from "../../../store/appointment/appointment-store";
import { useGeneralStore } from "../../../store/general/general-store";
import { formatDate, formatTimezone } from "../../../utils/helpers/date";
import { splitTextIntoLines } from "../../../utils/helpers/general";
import { LeftSideLoading } from "./left-side-loading";
import styles from "./left-side.module.scss";

export function LeftSide() {
  const { t } = useTranslation();
  const { setCurrentEventTypeId, setUserAppointmentData, appointmentData: { date, timeRange }, dateToDisplay }
    = useAppointmentStore();
  const { currentTimezone, currentStep } = useGeneralStore();
  const { data, isLoading } = useGetAvailableTimeSlots(dateToDisplay);

  useEffect(() => {
    setCurrentEventTypeId(data?.extra?.event_type?.id ?? 0);
    setUserAppointmentData(data ?? ({} as AvailableSlotsQueryDTO));
  }, [data, setCurrentEventTypeId]);

  if (isLoading)
    return <LeftSideLoading />;

  const userData = data?.extra?.event_type;
  return (
    <div className={styles.leftSideWrapper}>
      <div className={styles.infoWrapper}>
        <Avatar
          borderColor="grey"
          size={AvatarSizes.Size120}
          url={userData?.user_avatar}
        />

        <div className={styles.info}>
          <h3>{userData?.user_name}</h3>
          <span>{userData?.user_title}</span>
        </div>
      </div>

      <div className={styles.mainInfo}>
        <h2>{userData?.title}</h2>
        {/* time and meeting */}
        <div className={styles.timeAndMeeting}>
          {/* duration */}
          <div>
            <Icon
              icon="ClockLineIcon"
              color="var(--gray-400)"
              weight={IconWeight.Bold}
            />
            <span>
              {userData?.duration}
              {" "}
              {t("minutes")}
            </span>
          </div>
          {/* platform */}
          <div>
            <Icon
              icon="VideocameraLineIcon"
              size={IconSizes.Size16}
              color="var(--gray-400)"
              weight={IconWeight.Bold}
            />
            <span>{userData?.platform.title}</span>
          </div>
          {/* date and time */}
          {currentStep === 1 && (
            <>
              <div>
                <Icon
                  icon="CalendarSimpleLineIcon"
                  color="var(--gray-400)"
                  weight={IconWeight.Bold}
                />
                <span>{formatDate(date, currentTimezone)}</span>
              </div>

              <div>
                <Icon
                  icon="ClockLineIcon"
                  color="var(--gray-400)"
                  weight={IconWeight.Bold}
                />
                <span>{timeRange?.join(" - ")}</span>
              </div>
            </>
          )}
          {/* timezone */}
          {currentStep === 1 && (
            <div>
              <Icon
                icon="GlobeLineIcon"
                color="var(--gray-400)"
                weight={IconWeight.Bold}
              />
              <span>{formatTimezone(currentTimezone)}</span>
            </div>
          )}
        </div>
        {/* description */}
        <div className={styles.description}>
          <div>
            {splitTextIntoLines(userData?.description ?? "")}
          </div>
        </div>
      </div>
    </div>
  );
}
